export const SHOW = 'loading.show';
export const HIDE = 'loading.hide';

export function show(ns, id) {
    return {type: SHOW, payload: {ns, id}};
}

export function hide(ns, id) {
    return {type: HIDE, payload: {ns, id}};
}
